import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ChildrenItems, RouteInfo, ROUTES } from '../sidebar/sidebar.component';
import { Router, NavigationEnd } from '@angular/router';
import { CognitoService } from '../../services/cognito/cognito.service';
import { filter } from 'rxjs/operators';
import { assetUrl, Utilities } from 'src/app/services/utilities';
import { NavigationTarget } from 'src/app/services/constants';
import { ChangelogService } from 'src/app/services/changelog/changelog.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChangelogComponent } from 'src/app/dialogs/changelog/changelog.component';
import { UrlLink } from 'src/app/url-links';
import { confirm } from 'devextreme/ui/dialog';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ChangeLogsModel } from 'src/app/models/changelog.models';
import { UserClaims } from 'src/app/models/user.claims';

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

declare var $: any;

@Component({
  selector: 'app-navbar-cmp',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit {
  public logoOV = assetUrl('img/overview_IS.png');
  public logoSN = assetUrl('img/selfnet_IS.png');
  private listTitles: any[];
  public titleAr: string;
  private sidebarVisible: boolean;
  public data: any;
  currentUserName: string;
  public urlLink = UrlLink;

  // Timers
  private readonly REFRESH_CHANGELOG_MS: number = 20000;
  private changelogInterval: NodeJS.Timer;

  // App version
  public numberVersion: number = 0;

  constructor(private cognitoService: CognitoService, private router: Router, public changelogService: ChangelogService, private dialog: MatDialog, private configurations: ConfigurationService) {
    this.sidebarVisible = false;
    this.listTitles = ROUTES.filter(listTitle => listTitle);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const pageUrl = event.urlAfterRedirects;

      // recoursive search
      this.titleAr = this.findTitleByPath(this.listTitles, pageUrl);
    });
  }

  findTitleByPath(list: RouteInfo[], url: string): string {
    for (let item of list) {
      // Check if path is equals
      if (url === item.path) {
        return item.title;
      }

      // If children is not empty, run recoursive search
      if (item.children && item.children.length > 0) {
        const foundInChildren = this.findChildrenTitle(item.children, url);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return ''; // return empty value if not found value
  }

  findChildrenTitle(children: ChildrenItems[], url: string): string {
    for (let subItem of children) {
      // Verifica se il path corrisponde
      if (url.includes(subItem.path)) {
        return subItem.title;
      }

      // Se ha dei children, esegui la ricerca ricorsiva
      if (subItem.children && subItem.children.length > 0) {
        const foundInSubChildren = this.findChildrenTitle(subItem.children, url);
        if (foundInSubChildren) {
          return foundInSubChildren;
        }
      }
    }
    return ''; // Se non trovato, restituisci una stringa vuota
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName('body')[0];
    if (misc.sidebar_mini_active === true) {
      body.classList.remove('sidebar-mini');
      misc.sidebar_mini_active = false;
      let hoverInv = document.getElementsByClassName('sidebar-mini');
      for (let i = 0; i < hoverInv.length; i++) {
        (<any>hoverInv[i]).style.display = 'none';
      }
    } else {
      setTimeout(function () {
        body.classList.add('sidebar-mini');
        document.getElementsByClassName('sidebar-mini');
        let hoverInv = document.getElementsByClassName('sidebar-mini');
        for (let i = 0; i < hoverInv.length; i++) {
          (<any>hoverInv[i]).style.display = 'block';
        }
        misc.sidebar_mini_active = true;
      }, 100);
    }
  }

  ngOnInit() {
    this.cognitoService.user.subscribe((user: UserClaims) => {
      this.currentUserName = user?.email ?? '';
    });
    this.showUpdatePortalVersion();
  }

  showUpdatePortalVersion() {
    this.changelogInterval = setInterval(() => this.getChangeLog(false), this.REFRESH_CHANGELOG_MS)
  }

  private getChangeLog(show?: boolean) {
    this.changelogService.getChangelog().subscribe(changes => {
      const lastVersion = changes.changeLogs[0];
      this.configurations.appVersion = lastVersion.version
      this.numberVersion = Number(`${lastVersion.major}${lastVersion.minor}${lastVersion.patch}`);

      if (this.configurations.hideFeatures) {
        this.configurations.hideFeatures = !(this.configurations.localVersion != this.numberVersion);
      }

      if (this.configurations.localVersion !== this.numberVersion) {
        this.clearIntervalRefresh();
        confirm(`Nuova versione ${lastVersion.version} disponibile!<br>Si consiglia di aggiornare la pagina appena possibile per garantire il corretto funzionamento del portale.<br><br>Si desidera ricaricare subito la pagina?`, "Aggiornamento portale")
          .then(dialogResult => {
            if (dialogResult) {
              this.configurations.localVersion = this.numberVersion
              window.location.reload();
            }
          });
      }
      if (show && (this.configurations.localVersion != this.numberVersion || !this.configurations.hideFeatures)) {
        this.showChangeLogPopup(changes);
      }
    });
  }

  private showChangeLogPopup(changes: ChangeLogsModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      changes: changes,
      numberVersion: this.numberVersion
    };
    dialogConfig.width = "85%";
    dialogConfig.position = { top: '5%' };
    this.dialog.open(ChangelogComponent, dialogConfig);
  }

  private clearIntervalRefresh() {
    if (this.changelogInterval) {
      clearInterval(this.changelogInterval);
      this.changelogInterval = null;
    }
  }

  sidebarOpen() {
    const body = document.getElementsByTagName('body')[0];

    var $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');

    if (body.querySelectorAll('.main-panel')) {
      document.getElementsByClassName('main-panel')[0].appendChild($layer);
    } else if (body.classList.contains('off-canvas-sidebar')) {
      document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
    }

    setTimeout(function () {
      $layer.classList.add('visible');
    }, 100);

    $layer.onclick = function () {
      body.classList.remove('nav-open');
      this.sidebarVisible = false;

      $layer.classList.remove('visible');
      setTimeout(function () {
        $layer.remove();
      }, 400);
    }.bind(this);

    body.classList.add('nav-open');
    this.sidebarVisible = true;
  }
  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];

    this.sidebarVisible = false;
    body.classList.remove('nav-open');
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  signOut() {
    this.cognitoService.handleSignOut();
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  /**
   * Go to overview portal.
   * */
  gotooverview() {
    Utilities.goto(NavigationTarget.OVERVIEW);
  }

  /**
   * Go to selfnet portal.
   * */
  gotoselfnet() {
    Utilities.goto(NavigationTarget.SELFNET);
  }

  /**
   * Open the version history dialog
   */
  public openDialog() {
    this.data = this.changelogService.loadChangeLogs().subscribe((res) => {
      this.data = res;
      this.dialog.open(ChangelogComponent, this.data);
    });
  }

  refreshPage() {
    window.location.reload();
  }
}
